"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageIdRestoreStrategy = void 0;
var RestoreStrategy_1 = require("./RestoreStrategy");
var MessageIdRestoreStrategyBuilder = /** @class */ (function () {
    function MessageIdRestoreStrategyBuilder() {
    }
    MessageIdRestoreStrategyBuilder.prototype.withId = function (id) {
        this.id = id;
        return this;
    };
    MessageIdRestoreStrategyBuilder.prototype.build = function () {
        return new MessageIdRestoreStrategy(this.id);
    };
    return MessageIdRestoreStrategyBuilder;
}());
exports.default = MessageIdRestoreStrategyBuilder;
var MessageIdRestoreStrategy = /** @class */ (function (_super) {
    __extends(MessageIdRestoreStrategy, _super);
    function MessageIdRestoreStrategy(id) {
        var _this = _super.call(this, 'message_id') || this;
        _this.id = id;
        return _this;
    }
    return MessageIdRestoreStrategy;
}(RestoreStrategy_1.default));
exports.MessageIdRestoreStrategy = MessageIdRestoreStrategy;
//# sourceMappingURL=MessageIdRestoreStrategyBuilder.js.map